import { InfoOutlineIcon } from '@ikyucom/design-system-icons-react'
import type { ComponentType } from 'react'
import { isWithinInterval } from '~/lib/date/dateTime'
import type { DateTime } from '~/lib/graphql/scalars'
import { useNow } from '~/stores/now'
import { css } from '~/styled-system/css'
import { hstack, vstack } from '~/styled-system/patterns'

//  FIXME: 本来は macaron-backend から tbl_siteAnnouncement の値を取得するべき
//         https://github.com/ikyucom/macaron-frontend/issues/4120
export function Announce() {
  const now = useNow()

  const announcements = ANNOUNCEMENTS.filter(({ start, end }) => isWithinInterval(now, start, end))
  if (announcements.length === 0) {
    return null
  }

  return (
    <div className={vstack({ gap: '2', alignItems: 'stretch', _sd: { px: '3', pb: '3' } })}>
      {announcements.map(({ key, Text }) => (
        <div
          key={key}
          className={hstack({ gap: '2', p: '3', bgColor: 'gray.100', rounded: 'default' })}
        >
          <InfoOutlineIcon className={css({ fontSize: '2xl', flexShrink: '0' })} />
          <p className={css({ fontSize: 'sm' })}>
            <Text />
          </p>
        </div>
      ))}
    </div>
  )
}

type Announcement = {
  key: string
  start: DateTime
  end: DateTime
  Text: ComponentType
}

const ANNOUNCEMENTS: Announcement[] =
  import.meta.env.VITE_MODE === 'ppg'
    ? []
    : [
        // ikyu
        {
          key: 'point-program',
          start: '2025-03-05T10:00:00.000+09:00' as DateTime,
          end: '2025-03-31T23:59:59.999+09:00' as DateTime,
          Text: PointProgram,
        },
        {
          key: 'point-program-after-renewal',
          start: '2025-04-01T00:00:00.000+09:00' as DateTime,
          end: '2025-04-14T23:59:59.999+09:00' as DateTime,
          Text: PointProgramAfterRenewal,
        },
      ]

function PointProgram() {
  return (
    <>
      2025年4月1日に一休.comレストランのポイント付与率を変更いたします。
      <a href="https://my.ikyu.com/membership/" className={css({ color: 'link' })} target="_blank">
        詳しくはこちら
      </a>
    </>
  )
}

function PointProgramAfterRenewal() {
  return (
    <>
      2025年4月1日に一休.comレストランのポイント付与率を変更しました。
      <a href="https://my.ikyu.com/membership/" className={css({ color: 'link' })} target="_blank">
        詳しくはこちら
      </a>
    </>
  )
}
